// -- React Libraries
import React from 'react';
import ReactExport from "react-data-export";
import ButtonAction from '../../../components/ButtonAction';

// -- Styles
import StyleWrapper from "./Wrapper";

// -- Others
import DownloadIcon from "../../../image/download_aso.png";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default class AppScoreReport extends React.Component {
    render() {
        return (
            <StyleWrapper className="app-summary">
                <ExcelFile element={<ButtonAction title="Download Data"><img src={DownloadIcon}/></ButtonAction>}>
                <ExcelSheet data={this.props.report} name="Employees">
                    <ExcelColumn label="Category" value="cat"/>
                    <ExcelColumn label="Sub Category" value="subCat"/>
                    <ExcelColumn label="Result" value="result"/>
                    <ExcelColumn label="Detail" value="detail"/>
                    <ExcelColumn label="Insightful Tip 1" value="tip1"/>
                    <ExcelColumn label="Insightful Tip 2" value="tip2"/>
                    <ExcelColumn label="Insightful Tip 3" value="tip3"/>
                </ExcelSheet>
            </ExcelFile>
            </StyleWrapper>
        );
    }
};


// WEBPACK FOOTER //
// ./src/containers/AsoAnalytic/AppScoreReport/index.js